import { useEffect, useEffectEvent, useState } from 'react';

export function useShowLoadingDelayed(isLoading: boolean, delayMs = 700): boolean {
  const [showLoading, setShowLoading] = useState(false);

  const onLoadingStarted = useEffectEvent(() => {
    return setTimeout(() => {
      setShowLoading(true);
    }, delayMs);
  });

  const onLoadingFinished = useEffectEvent(() => setShowLoading(false));

  useEffect(() => {
    if (isLoading) {
      const timeoutToken = onLoadingStarted();

      return () => clearTimeout(timeoutToken);
    } else {
      onLoadingFinished();
      return () => {};
    }
  }, [isLoading]);

  return showLoading;
}
